// Service worker registration helper for ATHINAPPY.
//
// We are temporarily running in "no PWA" mode: the registration function
// below actively unregisters any previously-installed service worker and
// clears all caches so users immediately pick up the latest JS bundle after
// each deploy. We can bring the PWA features back once the caching strategy
// is proven safe.

export function register() {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;

  // Keep registering the SW *file* (which is now a self-destruct SW) so that
  // existing users running an older PWA version get the "clean up" code and
  // unregister themselves on their next page load.
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then(async (registration) => {
        // Force an update check on every page load to accelerate rollout.
        registration.update().catch(() => {});
      })
      .catch(() => {
        /* silent */
      });

    // Belt-and-braces: if there are already registered SWs from older versions,
    // and no self-destruct SW took effect yet, forcibly unregister them.
    navigator.serviceWorker.getRegistrations().then((regs) => {
      regs.forEach((reg) => {
        // Give the self-destruct SW a moment to run, then unregister anything
        // still around.
        setTimeout(() => reg.unregister().catch(() => {}), 2000);
      });
    });

    // Clear all caches managed by the Cache API, just in case.
    if (window.caches && window.caches.keys) {
      window.caches.keys().then((keys) => {
        keys.forEach((k) => window.caches.delete(k).catch(() => {}));
      });
    }
  });
}

export function unregister() {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;
  navigator.serviceWorker.ready
    .then((registration) => registration.unregister())
    .catch(() => {});
}
